import React, { useEffect, useState } from 'react';

import { CustomImageInterface } from '../../interfaces';
import { ImageWrapper } from './styled';


const VeliImage: React.FC<CustomImageInterface> = ({ className, classNameWrapper, src, thumb, alt, lazy, contain }) => {
    const [clientLoaded, isLoaded] = useState(false);
  
    useEffect(() => {
      isLoaded(true);
    }, []);
    return (
      <ImageWrapper className={classNameWrapper} contain={contain}>
        {clientLoaded ? (
          <>
            {'loading' in HTMLImageElement.prototype ? (
              <>
                {src && <img className={className} src={src} alt={alt} loading={lazy ? 'lazy' : 'eager'} />}
                {thumb ? <img className={`thumb ${className}`} src={thumb} alt={alt} loading="eager" /> : ''}{' '}
              </>
            ) : (
              <>
                {src && <img className={className} src={src} alt={alt} />}
                {thumb ? <img className={`thumb ${className}`} src={thumb} alt={alt} /> : ''}
              </>
            )}
          </>
        ) : (
          <></>
        )}
      </ImageWrapper>
    );
  };
  
  export default VeliImage;
  